import { render, staticRenderFns } from "./price-changer.vue?vue&type=template&id=065a5345&"
import script from "./price-changer.vue?vue&type=script&lang=ts&"
export * from "./price-changer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports